import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { systemRoutes } from 'system/router/routing-config';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface EventManagerCollapseProps {
  onSubItemClick?: () => void;
  link: string;
}

const EventManagerCollapse = ({
  onSubItemClick,
  link,
}: EventManagerCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const items = useRouteAuthorization(systemRoutes[0].children[0].children[1]?.children);

  return (
    <Fragment>
      <ListItem
        button
        key="Event Manager"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Event Manager" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items
            .filter((route) => !route.hidden)
            .map((systemRoute) => (
              <Link
                key={`${link}/${systemRoute.path}`}
                to={`${link}/${systemRoute.path}`}
                className="pmi-anchor"
              >
                <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                  <ListItemText className={classes.colorItems} primary={systemRoute.name} />
                </ListItem>
              </Link>
            ))}
        </List>
      </Collapse>
    </Fragment>
  );
};

EventManagerCollapse.displayName = 'EventManager Collapse Item';

export default EventManagerCollapse;
